export const DEFAULT_MASKED_PAYMENT_CARD_NUMBER = '****************';

export const formatPaymentCardNumber = (cardNumber: string = DEFAULT_MASKED_PAYMENT_CARD_NUMBER): string => {
  return cardNumber.replace(/.{4}(?=.)/g, '$& ');
};
